<template>
  <div>
    <div
      v-if="activeUserId"
      :class="[
        'users__user-details__container',
        { 'users__user-details__container--clickable': activeUser.isActive }
      ]"
      @click.prevent="handleClickUserProfile(activeUser.id)"
      @keyup.enter="handleClickUserProfile(activeUser.id)"
    >
      <user-avatar
        :activeUser="activeUser"
        size="small"
        class="u-m-r-small"
      />
      <div>
        <span>
          <user-display-name
            :activeUserId="activeUser.id"
            size="medium"
            is-inline
            :is-clickable="activeUser.isActive"
          />
          <team-tag
            v-for="team in getUserTeams(activeUser.id, teams)"
            :key="team.id"
            :teamId="team.id"
          />
          <small
            v-if="!activeUser.isActive"
            class="has-text-danger is-size-7 is-italic"
          >
            User Archived
          </small>
        </span>
        <p
          :class="[
            'subtitle',
            'is-size-6',
            'has-text-grey',
          ]"
        >
          {{ activeUser.email }}
        </p>
      </div>
    </div>
    <div v-else-if="activeInvitationId" class="users__user-details__container">
      <user-avatar
        :user="{}"
        size="small"
        class="u-m-r-small"
      />
      <div>
        <span>
          <h6 class="title is-6 is-inline">{{ activeInvitation.inviteeEmail }}</h6>
          &nbsp;
          <team-tag :key="activeInvitation.teamId" :teamId="activeInvitation.teamId" />
        </span>
        <p class="subtitle is-size-6">
          <span class="has-text-grey">
            Invited on: {{ activeInvitation.createdAt.toDate().toLocaleString('en-US') }}
          </span>
          <span class="has-text-info is-italic is-size-7">
            Invitation Pending
          </span>
          &nbsp;
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { getUserTeams } from '@/helpers/teamHelpers';
import UserDisplayName from '@/components/UserDisplayName.vue';
import TeamTag from '@/components/TeamTag.vue';
import UserAvatar from '@/components/UserAvatar.vue';

export default {
  name: 'UserListRow',

  components: {
    TeamTag,
    UserDisplayName,
    UserAvatar,
  },

  props: {
    activeUserId: {
      type: String,
      required: false,
      default: null,
    },
    activeInvitationId: {
      type: String,
      required: false,
      default: null,
    },
  },

  computed: {
    ...mapState({
      users: state => state.user.users,
      teams: state => state.team.teams,
      invitations: state => state.invitation.invitations,
    }),
    activeUser() {
      if (!this.activeUserId) return null;

      return this.users[this.activeUserId];
    },
    activeInvitation() {
      if (!this.activeInvitationId) return null;

      return this.invitations[this.activeInvitationId];
    },
  },

  methods: {
    getUserTeams,
    handleClickUserProfile(userId) {
      if (!this.users[userId].isActive) return;

      this.$router.push(`/users/edit-profile/${userId}`);
    },
  },
};
</script>

<style scoped lang="scss">
.users__user-details__container {
  display: flex;
  padding: $global-whitespace-small;

  &:hover {
    background-color: $white-bis;
  }
}

.users__user-details__container--clickable {
  cursor: pointer;

  &:hover {
    border-left: 2px solid $info;
    margin-left: -2px;
  }
}
</style>
